import SceButton from '../../../../../../../../Common/CommonComponents/sceButton.js';
import SceText from '../../../../../../../../Common/TextBox/sceText.js';
import classes from './addPhoneDialogBox.scss';
import { getLocalizedStrings } from './popUpCommonStrings.js';
import RadioGroup from '../../../../../../../../Common/CommonComponents/radioButton.js';
import Modal from 'react-awesome-modal';
/***********************
Change type : Security changes for phone numbers
Changed by: Sai Aman Pothuganti
Date : 06-10-2020
************************/
import GlobalErrorBlock from '../../../../../../../../Common/CommonComponents/GlobalErrorBlock/globalErrorBlock';
import ErrorStrings from '../../../errorStrings';


const AddTextDialogBox = (props) => {
  const strings = getLocalizedStrings('addEmailDialog');
  const loadingSpinner = props.showSpinner ? <div className={classes.sceRightIcon}>
  <i className='fa fa-spinner fa-spin' /></div> : null ;
  return (
    <div className={classes.scrollDiv}>
    <Modal
      visible='true'
      effect="fadeInUp"
      width="100%"
      height="100%">
    <div className={classes.sceAddEmailDialog}>
      <div className={'row ' + classes.sceAddEmailDialogWrap}>
        <div className={'col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 ' + classes.sceAddEmailDialogMain}>
          <div className={classes.sceCancelDialogSection}>
            {props.isLocalError ? <GlobalErrorBlock errorMessage={ErrorStrings["DEFAULT"]} /> : null}
            <div className={classes.sceCancelDialogInfo}>
              <div className={classes.sceDialogMainContent}>{strings.addNewTextHeading}</div>
              <div className={classes.sceDialogSubContent}>
                <SceText placeholder='Enter Mobile Number'
                  type='cppResPhone'
                  maxLength={13}
                  id='addTextMessageNum'
                  validator={app.appUtil.validator}
                  forceValidate={props.forceValidate}
                  isError={props.addTextMessageNum.isError}
                  isValid={props.addTextMessageNum.isValid}
                  errorMsg={props.addTextMessageNum.errorMsg}
                  onTextUpdatedHandler={props.retrievedataFromTextBoxes}
                  onFocusHandler={props.onFocusHandler}
                />
                {loadingSpinner}
              </div>
              <div className={classes.sceRadio}>
                {props.options.map((textList, i) => {
                  return (
                    <div key={'radio' + i}>
                      <RadioGroup
                        options={[textList]}
                        type='radio'
                        validStyle={props.selectedOptionValidStyle}
                        radioOutLineFlag={props.radioOutline}
                        selectedOptions={props.selectedOptions}
                        onClick={(event) => props.onMobileRadioClick(event, i)}
                      // onFocus={(event) => props.onRadioFocus(event, i)}

                      />  
                    </div>
                  );
                })
                }
              </div>

            </div>
            <div className={'row ' + classes.sceCancelDialogActions}>
              <div className={'col-xs-12 col-sm-6 col-sm-push-6 ' + classes.sceConfirmBtn}>
                <SceButton
                  id='cancelDialogYes'
                  buttonType={props.addTextMessageNum.value === '' || props.addTextMessageNum.isError || props.selectedOptions === '' || props.isLocalError || props.showSpinner ? 'default' : 'sceSmPrimary'}
                  value={strings.btnConfirm}
                  responive='false'
                  isDisabled={props.selectedOptions === ''}
                  onClick={props.addTextMessageNum.value === '' || props.selectedOptions === '' || props.isLocalError || props.showSpinner? (e)=>e.preventDefault() : props.onAddTextMessageConfirmDialogClick}
                />
              </div>
              <div className={'col-xs-12 col-sm-6 col-sm-pull-6 ' + classes.sceCancelBtn}>
                <SceButton
                  id='cancelDialogNo'
                  buttonType='sceClose'
                  value={<span id={'cancelDialogno'}>{strings.btnCancel}</span>}
                  responive='false'
                  onClick={(e) => props.onCancelClickHandler(e)}
                  iconType='cancel'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </Modal>
    </div>

  );
};
export default AddTextDialogBox;